module.exports = __webpack_public_path__ + "fonts/苹方-Regular.75225b29.ttf";